import { FC, ReactNode, useCallback } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface Props {
  children: ReactNode;
  hasLoadingError: boolean;
  onContinueAndDefault(): void;
}

export const BlotterPreferencesLoadingErrorModal: FC<Props> = ({ hasLoadingError, onContinueAndDefault, children }) => {
  const { formatMessage } = useIntl();

  const onRefreshed = useCallback(() => window.location.reload(), []);

  return (
    <>
      {children}
      <Modal show={hasLoadingError}>
        <ModalHeader>
          <ModalTitle data-e2e="user-preferences-loading-error-modal-title" as="h3">
            {formatMessage({ id: 'userPreferences.loadingErrorModal.title' })}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <span data-e2e="user-preferences-loading-error-modal-text">
            {formatMessage({ id: 'userPreferences.loadingErrorModal.text' })}
          </span>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="secondary"
            size="lg"
            onClick={onRefreshed}
            data-e2e="user-preferences-loading-error-modal-refresh-btn"
          >
            {formatMessage({ id: 'userPreferences.loadingErrorModal.button.refresh' })}
          </Button>
          <Button
            variant="primary"
            size="lg"
            onClick={onContinueAndDefault}
            data-e2e="user-preferences-loading-error-modal-continue-btn"
          >
            {formatMessage({ id: 'userPreferences.loadingErrorModal.button.continue' })}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
BlotterPreferencesLoadingErrorModal.displayName = 'BlotterPreferencesLoadingErrorModal';
